import type { MeterForProductPageResponse } from '@weft/api-definition';
import { VyIcon } from '@weft/icons';
import { withDefault } from '@weft/utils';
import React from 'react';
import type { VyTableMinimalProps } from '../../../../../components/new-design/table/vy-table/VyTable';
import { VyTable } from '../../../../../components/new-design/table/vy-table/VyTable';
import { VyTableToolbar } from '../../../../../components/new-design/table/vy-table-toolbar/vy-table-toolbar';
import { useSearchWithSearchParams } from '../../../../../hooks/use-search-with-search-params';
import { CreateProductDialog } from '../CreateProductDialog/CreateProductDialog';
import { METERS_COLUMNS } from './meters-table-columns';

export const MetersTable: React.FC<VyTableMinimalProps<MeterForProductPageResponse>> = ({ items, itemsCount, loadingItems }) => {
  const [metersQuery, setCustomersSearch] = useSearchWithSearchParams();

  return (
    <>
      <VyTableToolbar>
        <VyTableToolbar.Queries>
          <VyTableToolbar.SearchInput
            onChange={(event) => setCustomersSearch(event.target.value)}
            defaultValue={withDefault(metersQuery, '')}
            placeholder="Search"
            label={undefined}
          />
        </VyTableToolbar.Queries>

        <VyTableToolbar.Actions>
          <CreateProductDialog>
            <VyTableToolbar.CtaButton sx={{ columnGap: '12px' }}>
              <VyIcon icon="PlusMedium"/>
              Create New
            </VyTableToolbar.CtaButton>
          </CreateProductDialog>
        </VyTableToolbar.Actions>
      </VyTableToolbar>

      <VyTable
        itemsCount={itemsCount}
        items={items}
        columns={METERS_COLUMNS}
        loadingItems={loadingItems}
        sx={{
          paddingBottom: '130px',
        }}
        getRowId={() => crypto.randomUUID()}
      />
    </>
  );
};